import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const FAQS = [
  {
    q: "Are you actually the carrier, or a broker?",
    a: "We are a direct carrier. We own the trucks, employ the drivers, and handle dispatch in-house. Your unit never gets re-listed or auctioned to a load-board stranger.",
  },
  {
    q: "Which provinces do you serve?",
    a: "British Columbia, Alberta, Saskatchewan, Manitoba, Ontario, Quebec, New Brunswick, Nova Scotia, PEI, Newfoundland and Yukon. We regularly run coast-to-coast and into Whitehorse on request.",
  },
  {
    q: "How are rates calculated?",
    a: "Based on distance, vehicle dimensions, open vs enclosed transport, and the season. Your quote is the price you pay — no broker uplift, no fuel-surcharge surprises.",
  },
  {
    q: "Is my RV / bike / boat insured in transit?",
    a: "Yes. We carry commercial cargo insurance on every load. Coverage details are provided with your quote and a condition-report with photos is completed at pickup and delivery.",
  },
  {
    q: "How far in advance should I book?",
    a: "Short runs: 3–7 days. Coast-to-coast: 1–3 weeks depending on season. Winter snowmobile season and spring RV season book out fastest.",
  },
  {
    q: "Do you offer enclosed motorcycle transport?",
    a: "Yes. All motorcycles ship in enclosed trailers with soft-tie / chock systems by default. Vintage, custom and show bikes get white-glove handling at no upcharge.",
  },
  {
    q: "Can you pick up from a remote cabin or farm?",
    a: "Yes — we regularly collect from rural properties, cottages, dealerships, auctions and storage yards. Share the pin and we'll sort the access.",
  },
  {
    q: "What's your damage / claims process?",
    a: "Photos on load, photos on unload, a human on the phone the same day. Because the same driver handles both ends, accountability never gets lost.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="bg-[#EAEAE5] border-b-2 border-[#122A1E]" data-testid="faq-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="font-mono-accent text-[11px] uppercase text-[#4A5550] mb-3">
              ◆ 005 · FAQ
            </div>
            <h2 className="font-display font-black uppercase tracking-tighter leading-none text-[#0A0E0C] text-4xl md:text-5xl">
              Straight
              <br />
              Answers.
            </h2>
            <p className="mt-5 text-[#4A5550] leading-relaxed">
              Still unsure? Call dispatch — a human will answer.
            </p>
          </div>

          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`q-${i}`}
                  className="border-2 border-[#122A1E] mb-3 bg-[#F4F4F1] data-[state=open]:hard-shadow-sm"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="px-5 py-4 hover:no-underline font-display font-bold uppercase text-sm md:text-base text-left text-[#0A0E0C]">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="px-5 pb-5 text-[#4A5550] text-base leading-relaxed">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
